/*
**************************** 
홈페이지 콘텐츠 구매 리스트
*****************************
*/

import axios from "axios";
import React, { useEffect, useState } from "react";
import BuyContentOrder from "./BuyContentOrder";

export default function BuyContent(props) {
    const [userData, setUserData] = useState({ username: "", name: "", email: "", phone: "", address: "", subAddress: "", password: "" });
    const [valueData, setValueData] = useState([]);

    const reqProduct = async function () {
        const reqSql = "/api/product/content";
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.data.t_count >= 0) {
                const data = res.data.t_data;
                setValueData(data);
            } else {
                if (res.status === 400) {
                    alert("세션 만료 로그인이 필요합니다.");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            if (err.code === "ERR_BAD_REQUEST") {
                alert("세션 만료 로그인이 필요합니다.");
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    useEffect(() => {
        reqProduct();
    }, []);

    return (
        <div className="mt-5 pt-2">
            <ol className="breadcrumb">
                <li className="breadcrumb-item small"><a href="#">구매하기</a></li>
                <li className="breadcrumb-item active small">콘텐츠 구독권</li>
            </ol>
            <div className="container">
                <main>
                    <div className="row row-cols-md-3">
                        {valueData.length > 0 ? valueData.map(function (cell, idx) {
                            const idAdd = "#" + cell.product_key + "_" + cell.id;
                            let msg = cell.msg.replace(/\n/gi, " ");
                            let shortStr = (msg.length > 40 ? msg.slice(0, 40) + "..." : msg);

                            const useType = cell.use_type;
                            const state = sessionStorage.getItem("state");
                            const userType = sessionStorage.getItem("userType");
                            const toktokSerial = sessionStorage.getItem("toktokSerial");
                            let contentBuyType;

                            if (state === "true" && toktokSerial != 'null') {
                                if (useType == userType) {
                                    contentBuyType = <button type="button" className="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" data-bs-target={idAdd}>구매하기 </button>
                                } else {
                                    if (userType < 2) {
                                        contentBuyType = <button type="button" className="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" onClick={() => {
                                            if (userType == 0 && useType == 1) { //기업상품
                                                alert("일반 소비자 콘텐츠를 구매해 주세요");
                                            } else if (userType == 1 && useType == 0) {
                                                alert("기관용 콘텐츠를 구매해 주세요");
                                            }

                                        }}>구매하기 </button>
                                    } else {
                                        contentBuyType = <button type="button" className="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" data-bs-target={idAdd}>구매하기 </button>
                                    }
                                }
                            } else {
                                if (toktokSerial == 'null') {
                                    contentBuyType = <button type="button" className="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" onClick={() => {
                                        alert("톡톡박스 시리얼번호 등록이 필요한 메뉴입니다.");
                                    }}>구매하기 </button>
                                } else {
                                    contentBuyType = <button type="button" className="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" onClick={() => {
                                        alert("로그인 후 이용해 주세요.");
                                    }}>구매하기 </button>
                                }
                            }

                            return (
                                <div key={idx}>
                                    <div className="col pt-3">
                                        <div className="card rounded-3 shadow-sm" >

                                            <div className="card-body" >
                                                <img className="img-thumbnail" src={cell.product_thum_image}></img>
                                                <ul className="list-unstyled mt-3 mb-4">
                                                    <li className="text-start my-3 fw-4">{shortStr}</li>
                                                </ul>
                                                {contentBuyType}
                                            </div>
                                        </div>
                                    </div>
                                    <BuyContentOrder data={cell} user={userData}></BuyContentOrder>
                                </div>
                            )
                        }) : null}
                    </div>
                </main>

            </div>
        </div>
    )
}